import { render, staticRenderFns } from "./Box9new.vue?vue&type=template&id=d9ebdac6&scoped=true&"
import script from "./Box9new.vue?vue&type=script&lang=js&"
export * from "./Box9new.vue?vue&type=script&lang=js&"
import style0 from "./Box9new.vue?vue&type=style&index=0&id=d9ebdac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ebdac6",
  null
  
)

export default component.exports